export default __webpack_public_path__ + "static/media/Ltst-5.972ea349.jpg";